module.exports = __webpack_public_path__ + "static/media/incheon.674878e0.png";